const path = require('path');
const pageloader = require(path.join(__dirname, "pageloader"));

const loader = new pageloader(path.join(__dirname, '../pages/news'));
const sortedNewsIDs = loader.getSortedFolderIDs();


export default {
  large: [
    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['noMobilePaddingTop'],
        sections: [
          {
            full: {
              component: 'article-block',
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'sandOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                header1: 'Other news'
              }
            },
            bottom: {
              component: 'article-loader',
              data: {
                columns: 3,
                blockModifiers: ['endMargin', 'alignTop', 'wrapColumns'],
                startIndex: sortedNewsIDs.length - 1,
                buttonText: 'More',
                folder: 'news',
                buttonRedirect: false,
                sortedIDs: sortedNewsIDs
              }
            },
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Article.js